import React from 'react';
import { Text } from '@/components/ui/text/Text';
import { colors } from '@/assets/styles/colors';


export type HourCounterBadgeVariant = 'info' | 'success' | 'warning' | 'error';

interface HourCounterBadgeProps {
  value: string;
  variant: HourCounterBadgeVariant;
  className?: string;
  'data-testid'?: string;
}

type VariantColors = { background: string; text: string };

const getVariantColors = (variant: HourCounterBadgeVariant): VariantColors => {
  switch (variant) {
    case 'success':
      return {
        background: colors.feedback.hourTargetMet100,
        text: colors.feedback.hourTargetMet400,
      };
    case 'warning':
      return { background: colors.notification.alertBackground, text: colors.feedback.alert300 };
    case 'error':
      return { background: colors.notification.errorBackground, text: colors.feedback.error300 };
    case 'info':
    default:
      return { background: colors.notification.importantBackground, text: colors.important.main };
  }
};

export const HourCounterBadge: React.FC<HourCounterBadgeProps> = ({
  value,
  variant,
  className,
  'data-testid': dataTestId,
}) => {
  const { background, text } = getVariantColors(variant);

  return (
    <div
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: 9999,
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 16,
        paddingRight: 16,
        backgroundColor: background,
      }}
      data-testid={dataTestId}
    >
      <Text variant="subheader-medium" color={text}>
        {value}
      </Text>
    </div>
  );
};

export default HourCounterBadge;
